import { render, staticRenderFns } from "./peopleinfo.vue?vue&type=template&id=1b0d1604&scoped=true"
import script from "./peopleinfo.vue?vue&type=script&lang=js"
export * from "./peopleinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d1604",
  null
  
)

export default component.exports